<template>
  <div>
    <div class="d-flex flex-column flex-md-row my-5 align-center">
      <div class="d-flex flex-column">
        <div class="font-weight-bold">
          Grupos de questões
        </div>
        <div class="text-body-2 text--secondary mt-1">
          As questões são organizadas em grupos, você pode criar novos grupos e adicionar questões a eles.
        </div>
      </div>
      <v-spacer />
      <v-btn
        color="primary"
        text
        :disabled="exam.is_published"
        @click="openNewQuestionGroupDialog"
      >
        <v-icon
          small
          left
        >
          mdi-plus
        </v-icon>  Novo grupo
      </v-btn>
    </div>
    <v-simple-table
      v-if="questionsView"
      fixed-header
    >
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <div
        v-else
        class="mr-5 ml-5"
      >
        <v-data-table
          :headers="headers"
          :items="questionsGroup"
          :items-per-page="10"
          item-key="id"
          no-data-text="Nenhum grupo de questões cadastrado ainda"
        >
          <template #item.title="{ item }">
            <router-link :to="{ name: 'exams.examId.groups.groupId', params: { examId: exam.id, groupId: item.id } }">
              {{ item.title }}
            </router-link>
          </template>
          <template #item.created_at="{ item }">
            <div class="d-flex flex-row justify-center">
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                :disabled="exam.is_published"
                @click="openEditQuestionGroupDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-1"
                outlined
                small
                fab
                color="primary"
                :disabled="exam.is_published"
                @click="deleteQuestionGroups(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-simple-table>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import EditQuestionGroupDialog from './EditQuestionGroupDialog.vue'
import NewQuestionGroupDialog from './NewQuestionGroupDialog.vue'
import utils from '@/api/utils.js'

export default {
  components: {
  },

  mixins: [
    handlesServerValidation
  ],

  props: {
    exam: { type: Object, required: true }
  },

  data () {
    return {
      loading: false,

      questionsGroup: [],
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Área do conhecimento',
          align: 'start',
          value: 'title'
        },
        {
          text: 'Disciplinas',
          align: 'start',
          value: 'subtitle'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'created_at'
        }
      ]
    }
  },
  computed: {
    questionsView () {
      return utils.checkPermissions('questions.view-any')
    },
    questionsCreate () {
      return utils.checkPermissions('questions.create')
    },
    questionsUpdate () {
      return !utils.checkPermissions('grade-level-groups.update-any')
    },
    questionsDelete () {
      return !utils.checkPermissions('grade-level-groups.delete')
    }
  },
  watch: {
  },
  async mounted () {
    await this.listQuestionGroups()
  },
  methods: {
    async listQuestionGroups () {
      this.loading = true
      try {
        this.questionsGroup = await this.$api.listQuestionGroups(this.exam.id)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar listar grupos de questões.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },

    openNewQuestionGroupDialog () {
      this.$dialog.custom(NewQuestionGroupDialog).with({ idExam: parseInt(this.exam.id) }).show()
        .then(async (group) => {
          if (group) {
            await this.listQuestionGroups()
          }
        })
    },

    openEditQuestionGroupDialog (item) {
      this.$dialog.custom(EditQuestionGroupDialog).with({ group: item }).show()
        .then(async (group) => {
          if (group) {
            await this.listQuestionGroups()
          }
        })
    },

    async deleteQuestionGroups (group) {
      this.$dialog.confirm('Apagar Grupo de questões?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          this.loading = true
          try {
            await this.$api.deleteQuestionGroups(group.id)
            this.$store.dispatch('setSnackBar', { text: 'Grupo excluído com sucesso.' })
            await this.listQuestionGroups()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar excluir o grupo.', color: 'red' })
          } finally {
            this.loading = false
          }
        })
        .show()
    }
  }
}
</script>
